








import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
@Component({
    name: 'ResponsiveIcon'
})
export default class ResponsiveIcon extends Vue {
    @Prop({ type: String, default: '' })
    private imageUrl!:string;

    @Prop() altText!:string;

    @Prop({ type: Number, default: 0 })
    height!: number;

    // Number or e.g. 'auto'
    @Prop({ type: Number, default: 0 })
    width!: number;

    @Prop({ type: String, default: 'transparent' })
    private bgColor!: string;

    @Prop({ type: Boolean, default: false }) allowUpscale!:boolean;

    @Prop({ type: String, default: 'pad', validator: value => ['crop', 'pad', 'max'].includes(value as string) })
    private mode!: string;

    get imageSrcSets() {
        if (!(this.imageUrl)) return undefined;
        let bgColor = this.normalizedBgColor;
        if (bgColor) {
            bgColor = bgColor === 'transparent' ? '' : `&bgcolor=${bgColor}`;
        }
        const upscale = `&upscale=${this.allowUpscale}`;
        const mode = `&mode=${this.mode}`;
        return {
            x1: `${this.imageUrl}?width=${this.width / 2}&height=${this.height / 2}${bgColor}${upscale}${mode}`,
            x2: `${this.imageUrl}?width=${this.width}&height=${this.height}${bgColor}${upscale}${mode}`
        };
    }

    private get normalizedBgColor(): string {
        return this.bgColor ? this.bgColor.replace('#', '') : '';
    }
}
